Vue.component('admin-featured-streamers', {
    template: templates.adminFeaturedStreamers,
    data() {
        return {
            model: {
                eligibleStreamers: [],
                featuredStreamers: [],
                isLoading: false,
                error: null,
                featuredUntil: null,
                searchTerm: ''
            }
        };
    },
    computed: {
        currentFeaturedCount() {
            return this.model.featuredStreamers.length;
        },
        canAddMore() {
            return this.currentFeaturedCount < 3;
        },
        availableOrders() {
            const used = this.model.featuredStreamers.map(s => s.featuredOrder);
            return [1, 2, 3].filter(o => !used.includes(o));
        },
        filteredEligible() {
            const c = this;
            if (!c.model.searchTerm) {
                return c.model.eligibleStreamers.filter(s => !s.isFeatured);
            }
            const searchLower = c.model.searchTerm.toLowerCase();
            return c.model.eligibleStreamers.filter(s =>
                !s.isFeatured &&
                (s.twitchDisplayName.toLowerCase().includes(searchLower) ||
                 s.twitchLogin.toLowerCase().includes(searchLower))
            );
        },
        sortedFeaturedStreamers() {
            return this.model.featuredStreamers.slice().sort((a, b) => a.featuredOrder - b.featuredOrder);
        }
    },
    mounted() {
        this.loadEligibleStreamers();
    },
    methods: {
        loadEligibleStreamers() {
            const c = this;
            c.model.isLoading = true;
            c.model.error = null;

            featuredStreamerService.getEligible()
                .then(function(response) {
                    c.model.eligibleStreamers = response.data.eligible || [];
                    c.model.featuredStreamers = c.model.eligibleStreamers.filter(s => s.isFeatured);
                    c.model.isLoading = false;
                })
                .catch(function(error) {
                    console.error('Error loading eligible streamers:', error);
                    c.model.error = 'Failed to load eligible streamers';
                    c.model.isLoading = false;
                });
        },

        featureStreamer(streamer) {
            const c = this;

            if (!c.canAddMore) {
                alert('Maximum 3 featured streamers allowed. Please remove one first.');
                return;
            }

            const order = c.availableOrders[0] || 1;

            featuredStreamerService.setFeatured({
                twitchId: streamer.twitchId,
                isFeatured: true,
                featuredUntil: c.model.featuredUntil || null,
                featuredOrder: order
            })
            .then(function(response) {
                if (response.data.success) {
                    c.loadEligibleStreamers();
                } else {
                    alert(response.data.message || 'Failed to feature streamer');
                }
            })
            .catch(function(error) {
                console.error('Error featuring streamer:', error);
                alert('Failed to feature streamer');
            });
        },

        unfeatureStreamer(streamer) {
            const c = this;

            if (!confirm(`Remove ${streamer.twitchDisplayName} from featured?`)) {
                return;
            }

            featuredStreamerService.setFeatured({
                twitchId: streamer.twitchId,
                isFeatured: false
            })
            .then(function(response) {
                if (response.data.success) {
                    c.loadEligibleStreamers();
                } else {
                    alert(response.data.message || 'Failed to remove from featured');
                }
            })
            .catch(function(error) {
                console.error('Error unfeaturing streamer:', error);
                alert('Failed to remove from featured');
            });
        },

        updateOrder(streamer, newOrder) {
            const c = this;

            featuredStreamerService.setFeatured({
                twitchId: streamer.twitchId,
                isFeatured: true,
                featuredUntil: streamer.featuredUntil,
                featuredOrder: parseInt(newOrder)
            })
            .then(function(response) {
                if (response.data.success) {
                    c.loadEligibleStreamers();
                }
            })
            .catch(function(error) {
                console.error('Error updating order:', error);
            });
        },

        formatDate(dateString) {
            if (!dateString) return 'Indefinite';
            return new Date(dateString).toLocaleDateString();
        },

        openTwitchChannel(streamer) {
            window.open(`https://twitch.tv/${streamer.twitchLogin}`, '_blank');
        }
    }
});
